import { ElementType } from 'react';
import PolarisIcon from '@/components/_common/PolarisIcon';
import { Button, ButtonProps as MuiButtonProps } from '@mui/material';
import { styled } from '@mui/system';
import { Link } from 'react-router-dom';
import { selectOriginJobId } from '../../../../redux/selectors/jobSelectors';
import { useAppSelector } from '@/redux/hooks';

interface ButtonProps extends MuiButtonProps {
  component?: ElementType;
  to: string;
}

const OriginJob = ({assetOriginJob}: {assetOriginJob?: number}) => {
  const originJob = useAppSelector(selectOriginJobId);
  const originJobId = assetOriginJob || originJob || undefined; 

  if (!originJobId) return null;

  return (
    <StyledButton color="info" component={Link} variant="text" to={`/jobs/${originJobId}`} startIcon={<PolarisIcon icon="merge" height={16} />}>
      Origin Job: <strong style={{ marginLeft: 5 }}>J{originJobId}</strong>
    </StyledButton>
  );
};
export default OriginJob;

const StyledButton = styled(Button)<ButtonProps>`
  font-size: 0.88rem;
  margin-left: -7px;
  margin-top: -3px;
  padding: 3px 10px;
`;
